import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { MdOutlinePhotoCamera } from 'react-icons/md';
import { RiLayoutGridLine } from 'react-icons/ri';
import { FaLayerGroup } from 'react-icons/fa';
import CanvasUploadPanel from './CanvasUploadPanel';
import PhotobookTemplates from '../PhotoBook/PhotobookTemplates';
import LayerPanel from './LayerPanel';

type SectionKey = 'photos' | 'templates' | 'layers';

const C = {
  rail:       '#0d0f1a',
  railBorder: 'rgba(255,255,255,0.04)',
  content:    '#13151f',
  border:     'rgba(255,255,255,0.07)',
  text2:      '#9da3c8',
  text3:      '#5c6290',
  accent:     '#5b79ff',
  accentSoft: 'rgba(91,121,255,0.15)',
};

const railBtn = (active: boolean): React.CSSProperties => ({
  width: 52, borderRadius: 8,
  padding: '9px 4px',
  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5,
  cursor: 'pointer',
  color: active ? C.accent : C.text3,
  background: active ? C.accentSoft : 'none',
  border: 'none',
  transition: 'all 150ms',
  fontSize: 9,
  fontWeight: 600,
  letterSpacing: 0.4,
  textTransform: 'uppercase' as const,
});

const CanvasSidePanel = observer(() => {
  const [activeSection, setActiveSection] = useState<SectionKey>('photos');

  const tabs: { key: SectionKey; label: string; Icon: React.ElementType }[] = [
    { key: 'photos',    label: 'Photos',    Icon: MdOutlinePhotoCamera },
    { key: 'templates', label: 'Layouts',   Icon: RiLayoutGridLine },
    { key: 'layers',    label: 'Layers',    Icon: FaLayerGroup },
  ];

  return (
    <div style={{ display: 'flex', height: '100%', width: 300, flexShrink: 0 }}>
      {/* Icon rail */}
      <div style={{
        width: 60, minWidth: 60,
        background: C.rail,
        borderRight: `1px solid ${C.railBorder}`,
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        padding: '10px 4px', gap: 2,
      }}>
        {tabs.map(({ key, label, Icon }) => (
          <button key={key} style={railBtn(activeSection === key)} onClick={() => setActiveSection(key)}>
            <Icon style={{ fontSize: 18 }} />
            <span>{label}</span>
          </button>
        ))}
      </div>

      {/* Panel content */}
      <div style={{
        flex: 1, overflow: 'hidden',
        background: C.content,
        borderRight: `1px solid ${C.border}`,
        display: 'flex', flexDirection: 'column',
      }}>
        {activeSection === 'photos'    && <CanvasUploadPanel />}
        {activeSection === 'templates' && <PhotobookTemplates />}
        {activeSection === 'layers'    && <LayerPanel />}
      </div>
    </div>
  );
});

export default CanvasSidePanel;
